import { bannerService } from '../_services/';
import alerts from '../_components/alerts';
import Swal from 'sweetalert2';

export const bannerAction = {
    getBanner,
    getBannerById,
    onChangeProps,
    createBanner,
    editBannerInfo,
    deleteBannerById,
    onChangePropsConteudoArquivo,
    clear
};

function getBanner(showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'banners';
        bannerService.get(apiEndpoint)
            .then((response) => {
                dispatch(changeBannersList(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}

function editBannerInfo(id, payload) {
    return dispatch => {
        let apiEndpoint = 'banners/' + id;
        bannerService.put(apiEndpoint, payload)
            .then((response) => {
                if (response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(updatedUserInfo());
                    alerts.success(ret.message, '/banners');

                } else {
                    alerts.warning(response.request.responseText);
                }
            })
    }
}

function getBannerById(id, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'banners/' + id;
        bannerService.get(apiEndpoint)
            .then((response) => {
                dispatch(editBannersDetails(response.data));
                if (showWaiting) {
                    alerts.clean();
                }
            }).catch((err) => {
                console.log(err);
                alerts.error(err);
            })
    };
}

function createBanner(payload, showWaiting) {
    return dispatch => {
        if (showWaiting) {
            alerts.waiting();
        }
        let apiEndpoint = 'banners/';
        bannerService.post(apiEndpoint, payload)
            .then((response) => {
                if (response != undefined && response.request.status === 200) {
                    var ret = JSON.parse(response.request.responseText);
                    dispatch(createUserInfo());
                    if (showWaiting) {
                        alerts.clean();
                    }
                    dispatch(clear());
                    alerts.success(ret.message, '/banners');
                } else {
                    alerts.warning(response.data.Message);
                }
            })
    }
}

function deleteBannerById(id) {
    return dispatch => {
        Swal.fire({
            title: 'Confirmação',
            text: 'Tem certeza de que deseja excluir o registro?',
            icon: 'warning',
            buttons: true,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: "Não, cancelar!",
            dangerMode: true,
            heightAuto: false
        })
            .then((willDelete) => {
                if (willDelete.value) {
                    let apiEndpoint = 'banners/' + id;
                    bannerService.deleteDetail(apiEndpoint)
                        .then((response) => {
                            if (response.request.status === 200) {
                                var ret = JSON.parse(response.request.responseText);
                                dispatch(deleteBannersDetails());
                                dispatch(getBanner());
                                alerts.success(ret.message);
                            } else {
                                alerts.warning(response.request.responseText);
                            }
                        }).catch((err) => {
                            console.log(err.response);
                            return err.response;
                        })
                }
            });
    };
}

function onChangeProps(props, event) {
    return dispatch => {
        dispatch(handleOnChangeProps(props, event.target.value));
    }
}
function onChangePropsConteudoArquivo(props, event) {
    return (dispatch) => {
        dispatch(handleOnChangeProps(props, event))
    }
}

export function changeBannersList(banner) {
    return {
        type: "FETECHED_ALL_BANNER",
        banner: banner
    }
}

export function clear() {
    return {
        type: "BANNER_CLEAR"
    };
}

export function handleOnChangeProps(props, value) {
    return {
        type: "HANDLE_ON_CHANGE",
        props: props,
        value: value
    }
}

export function editBannersDetails(banner) {
    return {
        type: "BANNER_DETAIL",
        id: banner.id,
        nome: banner.nome,
        descricao: banner.descricao,
        caminho_imagem: banner.caminho_imagem,
        link: banner.link,
        data_cadastro: banner.data_cadastro,
        usuario_cadastro: banner.usuario_cadastro,
        data_exclusao: banner.data_exclusao,
        usuario_exclusao: banner.usuario_exclusao
    }
}

export function updatedUserInfo() {
    return {
        type: "BANNER_UPDATED"
    }
}

export function createUserInfo() {
    return {
        type: "BANNER_CREATED_SUCCESSFULLY"
    }
}

export function deleteBannersDetails() {
    return {
        type: "DELETED_BANNER_DETAILS"
    }
}